import Player from '@vimeo/player';
const backgroundVideoBlocks = [];
const videos = document.querySelectorAll(
	'.acf-block__background-video-wrapper [data-vimeo-url]'
);

const backgroundVideo = () => {
	if (videos.length) {
		videos.forEach((video) => {
			const parentBlock = video.closest('.acf-block');
			let backgroundImageWrapper;

			if (parentBlock) {
				backgroundVideoBlocks.push(parentBlock);

				parentBlock.style.setProperty(
					'--blockHeight',
					`${parentBlock.offsetHeight / 16}rem`
				);

				backgroundImageWrapper = parentBlock.querySelector(
					'.acf-block__background-image-wrapper'
				);
			}

			const player = new Player(video);

			player.setQuality('360p');

			player.on('play', function () {
				player.element.parentElement.classList.add('loaded');
			});

			Promise.all([player.getVideoWidth(), player.getVideoHeight()]).then(
				function (dimensions) {
					parentBlock.style.setProperty(
						'--videoRatio',
						`${dimensions[0] / dimensions[1]}`
					);
				}
			);

			if (backgroundImageWrapper) {
				backgroundImageWrapper.style.setProperty('--videoRatio', null);
			}
		});
	}
};

const setBackgroundVideoSize = () => {
	if (backgroundVideoBlocks.length) {
		backgroundVideoBlocks.forEach((backgroundVideoBlock) => {
			backgroundVideoBlock.style.setProperty(
				'--blockHeight',
				`${backgroundVideoBlock.offsetHeight / 16}rem`
			);
		});
	}
};

export { backgroundVideo, setBackgroundVideoSize };
